/**
 * Export Modal Configurations
 * 
 * Each config defines the visual appearance and text for a specific export modal.
 * Usage: <ExportModal {...EXPORT_CONFIGS.tariff} ... />
 */

export const EXPORT_CONFIGS = {
  // Tariff Data
  tariff: {
    title: 'Export Tariff Data',
    icon: '💰',
    description: 'This will export all tariff records to an Excel file including all columns (Part Number, HTS, Country, Mill, AD%, CV%, Section 232%, etc.).',
    accentColor: '#17a2b8',
    infoBgColor: '#d1ecf1',
    infoTextColor: '#0c5460',
    entityName: 'Tariff',
  },

  // Purchasing List
  purchasingList: {
    title: 'Export Purchasing List',
    icon: '🛒',
    description: 'This will export all purchasing list records to an Excel file including all columns (MTO details, COO, tariff percentages, prices, etc.).',
    accentColor: '#6f42c1',
    infoBgColor: '#f3e5f5',
    infoTextColor: '#6a1b9a',
    entityName: 'Purchasing List',
  },

  // HVAC Tracking
  hvac: {
    title: 'Export HVAC Tracking',
    icon: '❄️',
    description: 'This will export all HVAC tracking records to an Excel file including all columns (equipment info, progress percentages, budgeted/earned hours, etc.).',
    accentColor: '#17a2b8',
    infoBgColor: '#e0f7fa',
    infoTextColor: '#006064',
    entityName: 'HVAC',
  },

  // Rotating Equipment Tracking
  rotatingEquipment: {
    title: 'Export Rotating Equipment Tracking',
    icon: '⚙️',
    description: 'This will export all rotating equipment tracking records to an Excel file including all columns (equipment info, progress percentages, budgeted/earned hours, etc.).',
    accentColor: '#17a2b8',
    infoBgColor: '#fff3e0',
    infoTextColor: '#e65100',
    entityName: 'Rotating Equipment',
  },

  // Structural Steel Tracking
  structuralSteel: {
    title: 'Export Structural Steel Tracking',
    icon: '🏗️',
    description: 'This will export all structural steel tracking records to an Excel file.',
    accentColor: '#795548',
    infoBgColor: '#efebe9',
    infoTextColor: '#5d4037',
    entityName: 'Structural Steel',
  },

  // Vessels Tracking
  vessels: {
    title: 'Export Vessels Tracking',
    icon: '🛢️',
    description: 'This will export all vessels tracking records to an Excel file.',
    accentColor: '#6610f2',
    infoBgColor: '#ede7f6',
    infoTextColor: '#4527a0',
    entityName: 'Vessels',
  },

  // Ducts Tracking
  ducts: {
    title: 'Export Ducts Tracking',
    icon: '🔩',
    description: 'This will export all ducts tracking records to an Excel file including all columns (equipment info, progress percentages, budgeted/earned hours, etc.).',
    accentColor: '#20c997',
    infoBgColor: '#e6fffa',
    infoTextColor: '#0d7377',
    entityName: 'Ducts',
  },

  // Material Log
  materialLog: {
    title: 'Export Material Log',
    icon: '📦',
    description: 'This will export all material log records to an Excel file including all columns.',
    accentColor: '#fd7e14',
    infoBgColor: '#fff3cd',
    infoTextColor: '#856404',
    entityName: 'Material Log',
  },

  // Material Index
  materialIndex: {
    title: 'Export Material Index',
    icon: '📊',
    description: 'This will export all Material Index records to an Excel file including all columns (UID, Category, Description, Type, Material, HR, Dia In, Labour costs, etc.).',
    accentColor: '#343a40',
    infoBgColor: '#f8f9fa',
    infoTextColor: '#495057',
    entityName: 'Material Index',
  },

  // MTO (Material Take-Off)
  mto: {
    title: 'Export MTO Data',
    icon: '📋',
    description: 'This will export all MTO (Material Take-Off) records to an Excel file including all 54 columns.',
    accentColor: '#0d6efd',
    infoBgColor: '#e7f1ff',
    infoTextColor: '#0d6efd',
    entityName: 'MTO',
  },

  // Transmittal Log
  transmittal: {
    title: 'Export Transmittal Log',
    icon: '📋',
    description: 'This will export all Transmittal Log records to an Excel file including all columns (UID, Date, Job Number, Description, Status, etc.).',
    accentColor: '#343a40',
    infoBgColor: '#f8f9fa',
    infoTextColor: '#495057',
    entityName: 'Transmittal',
    exportButtonText: 'Export',
  },

  // Actual Spent Hours
  actualSpent: {
    title: 'Export Actual Spent Hours',
    icon: '📤',
    description: 'This will export all actual spent hours for this project to an Excel file including Employee, Trade, Division, Op Code, Reg/T12/DBL hours, and more.',
    accentColor: '#17a2b8',
    infoBgColor: '#e7f3ff',
    infoTextColor: '#0056b3',
    entityName: 'Actual Spent',
  },
};

export default EXPORT_CONFIGS;

